export enum MarketplaceItemType {
  cfp = 'cfp',
  avatar = 'avatar',
  gear = 'gear',
  icon = 'icon',
}

export const MARKETPLACE_ITEM_TYPES = Object.values(MarketplaceItemType);

const MARKETPLACE_ITEM_TYPE_LABELS: Record<MarketplaceItemType, string> = {
  [MarketplaceItemType.cfp]: 'CFP',
  [MarketplaceItemType.avatar]: 'Avatar',
  [MarketplaceItemType.gear]: 'Gear',
  [MarketplaceItemType.icon]: 'Icon',
};

export const formatMarketplaceItemType = (type: MarketplaceItemType): string =>
  MARKETPLACE_ITEM_TYPE_LABELS[type] ?? type;

export interface MarketplaceItem {
  id: string;
  type: MarketplaceItemType;
  title: string;
  description: string;
  price: number | null;
  imageUrl: string;
}
